<template>
  <div class="page_top_wrapper p_r">
    <page-nav
      @changeMover="changeMover"
      :active="active"
      :name="name"
      :visible="visible"
    >
    </page-nav>
    <div
      v-if="name != 'index'"
      :class="['page_banner', 'banner_' + name]"
      :style="{ height: height }"
    ></div>
    <div
      class="videoFragment_container"
      v-else
      style="width: 100%; height: 100vh"
    >
      <video
        class="videoFragment_player"
        src="/static/video/new.mp4"
        style="transform: translateY(calc(100vh - 100%))"
        loop
        autoplay
        muted
        webkit-playsinline
        playsinline
        x5-playsinline
        x5-video-player-type="h5-page"
      >
        <source src="/static/video/new.mp4" type="video/mp4" />
      </video>
      <!-- 看是否需要遮罩层 -->
      <!-- <div class="video_mask"></div> -->
      <div class="videoFragment_content">
        <div class="main_content">
          <h3>专注于产业数字化与产融综合解决方案</h3>
          <!-- <a class="player_start hand" @click="play = true"><i></i></a> -->
        </div>
      </div>
      <div class="player_modal" v-show="play">
        <div class="player_modal__mask"></div>
        <div class="player_modal__content">
          <a class="player_modal__close hand" @click="play = false"
            ><i class="el-icon-close"></i
          ></a>
          <video
            src="/static/video/new.mp4"
            controls
            autoplay
            loop
            muted
            webkit-playsinline
            playsinline
            x5-playsinline
            x5-video-player-type="h5-page"
          >
            <source src="/static/video/new.mp4" type="video/mp4" />
          </video>
        </div>
      </div>
    </div>
    <solution-menu
      @changeMover="changeMover"
      :visible="visible"
    ></solution-menu>
  </div>
</template>
<script>
import PageNav from "./PageNav";
import SolutionMenu from "./SolutionMenu";
export default {
  components: {
    PageNav,
    SolutionMenu,
  },
  props: {
    // 当前处于哪个 tab
    active: {
      type: [String, Number],
      required: true,
      default: 1,
    },
    //当前banner的高度
    height: {
      type: [Number, String],
      required: true,
      default: "100vh",
    },
    // 当前banner背景图的名字
    name: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      visible: false,
      play: false,
    };
  },
  methods: {
    changeMover(val, str) {
      if (val) {
        this.visible = true;
      } else if (!val && str == "pageNav") {
        this.visible = true;
      } else {
        this.visible = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.page_top_wrapper {
  width: 100%;
  height: max-content;

  .page_banner {
    width: 100%;
    top: 0;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    background-color: transparent;
  }

  .banner_index {
    background-image: url(/static/assets/szh_banner.png);
  }

  .banner_solution {
    background-image: url(/static/assets/solution_banner.png);
  }

  .banner_solution1 {
    background-image: url(/static/assets/solution1_banner.png);
  }

  .banner_solution2 {
    background-image: url(/static/assets/solution2_banner.png);
  }

  .banner_solution3 {
    background-image: url(/static/assets/solution3_banner.png);
  }

  .banner_case {
    background-image: url(/static/assets/case_banner.png);
  }

  .banner_technology {
    background-image: url(/static/assets/tech_banner.png);
  }

  .banner_party {
    background-image: url(/static/assets/party_banner.png);
  }

  .banner_about {
    background-image: url(/static/assets/about_banner.png);
  }

  .banner_news {
    background-image: url(/static/assets/news_banner.png);
  }

  .banner_product {
    background-image: url(/static/assets/product_banner.png);
  }

  .banner_product1 {
    background-image: url(/static/assets/product1_banner.png);
  }

  .banner_product2 {
    background-image: url(/static/assets/product2_banner.png);
  }

  .banner_product3 {
    background-image: url(/static/assets/product3_banner.png);
  }

  .banner_product4 {
    background-image: url(/static/assets/product4_banner.png);
  }

  .banner_product5 {
    background-image: url(/static/assets/product5_banner.png);
  }

  .banner_product6 {
    background-image: url(/static/assets/product6_banner.png);
  }
}

.videoFragment_container {
  position: relative;
  max-height: 100vh;
  width: 100%;
  overflow: hidden;
}

.videoFragment_container .videoFragment_player {
  background: transparent;
  width: 100%;
  display: block;
}

.video_mask {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 101;
  background: rgba(0, 0, 0, 0.2);
}

.videoFragment_content {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 201;
  height: 100%;
  display: flex;
  flex-direction: row;

  .main_content {
    display: flex;
    flex: 1 1;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    h3 {
      font-size: 44px;
      font-weight: normal;
      color: #fff;
      letter-spacing: 6px;
      font-family: "SourceHanSerifSC-Bold";
    }
    .player_start {
      display: inline-block;
      font-size: 40px;
      line-height: 40px;
      outline: none;
      transition: all 0.3s;
      color: #fff;
      margin-top: 30px;

      i {
        width: 52px;
        height: 52px;
        display: block;
        background: url("../assets/img/index/play.png") no-repeat;
        background-size: contain;
      }
    }
  }
}

.player_modal {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  position: fixed;
  transition: all 0.3s;
  z-index: 1001;

  .player_modal__mask {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.3);
  }

  .player_modal__content {
    max-width: 768px;
    margin: 170px auto 0;
    min-height: 427px;
    position: relative;

    .player_modal__close {
      position: absolute;
      top: 6px;
      right: 6px;
      width: 64px;
      height: 64px;
      text-align: right;
      font-size: 32px;
      line-height: 32px;
      outline: none;
      transition: all 0.3s;
      color: #fff;
      cursor: pointer;
      z-index: 301;
      text-align: center;
    }

    video {
      width: 100%;
      display: block;
      outline: none;
      line-height: 427px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PageTop.vue